import Widget from 'components/Widget/Widget';
import React from 'react';
import PropTypes from 'prop-types';
import PnLByDaysTable from './components/PnLByDaysTable';

const ProfitsAndLossesByDays = ({ height, data, index, configuration }) => {
  return (
    <Widget
      tableWidget
      widget_key={'daily_statistics' + index}
      title={data.title}
      index={index}
      disableLevelFilter
      disableLimit
      disableStatusFilter
      default_filter={data.defaultFilter}
      configuration={configuration}
      adsFilter
      adsetFilter
      campaignFilter
      showDatePicker
      showNetworkSwitcher
      position={data?.position}
      dashboard_widget_key={data?.key}
    >
      <PnLByDaysTable height={height} widget_key={'daily_statistics' + index} />
    </Widget>
  );
};

export default ProfitsAndLossesByDays;

ProfitsAndLossesByDays.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};
